
const _path = '/group/'

const GroupRouter:any = {
  meta: {
    title: '分群管理',
    icon: 'el-icon-s-grid'
  },
  children: [
    {
      path: _path + 'list',
      component: () => import('@/views/GroupAdmin/GroppList/index.vue'),
      meta: {
        title: '分群列表',
        hidden: false,
        keepAlive: true
      }
    },
    {
      path: _path + 'detail',
      component: () => import('@/views/GroupAdmin/GroupDetail/index.vue'),
      meta: {
        title: '分群详情',
        parentPath: _path + 'list',
        hidden: true
      }
    },
    {
      path: _path + 'add',
      component: () => import('@/views/GroupAdmin/AddGroup/index.vue'),
      meta: {
        title: '新增分群',
        parentPath: _path + 'list',
        hidden: true
      }
    }
  ]
}

export default GroupRouter
